/**
 * AutoCount - Add Supplier Page
 */

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

import { useNavigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function SuppliersAdd(): JSX.Element {
  const navigate = useNavigate();
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Add New Supplier
                </MDTypography>
              </MDBox>
              <MDBox p={3}>
                <MDTypography variant="h6" mb={2}>Company Information</MDTypography>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <MDInput label="Company Name *" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput label="Supplier Code *" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput label="Website" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput label="Payment Terms" fullWidth placeholder="e.g., Net 30" />
                  </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />

                <MDTypography variant="h6" mb={2}>Contact Information</MDTypography>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <MDInput label="Contact Name" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput label="Email" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput label="Phone" fullWidth />
                  </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />

                <MDTypography variant="h6" mb={2}>Address</MDTypography>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <MDInput label="Street Address" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput label="City" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput label="State" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput label="ZIP Code" fullWidth />
                  </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />

                <MDTypography variant="h6" mb={2}>Additional Settings</MDTypography>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <MDInput label="Lead Time (days)" type="number" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput label="Minimum Order Value ($)" type="number" fullWidth />
                  </Grid>
                  <Grid item xs={12}>
                    <MDInput label="Notes" fullWidth multiline rows={3} />
                  </Grid>
                </Grid>

                <MDBox mt={4} display="flex" justifyContent="flex-end" gap={2}>
                  <MDButton variant="outlined" color="secondary" onClick={() => navigate("/suppliers")}>Cancel</MDButton>
                  <MDButton variant="gradient" color="info" onClick={() => navigate("/suppliers")}>Save Supplier</MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SuppliersAdd;
